import {buildStore} from "./store/store";
import {initApp} from "./init";

import * as windowService from "./services/windowService";

const store = buildStore();

initApp(store, windowService.getCustomStylePath());
